import React from "react";
import styled from "styled-components";
import { theme } from "../theme";

const Styles = {
  Title: styled.span`
    color: ${({ color }) => color};
    font-size: 1.3rem;
    line-height: 3rem;
    margin-left: -1rem;
  `,
  Label: styled.span`
    display: inline-block;
    width: 2.2rem;
    height: 2.2rem;
    line-height: 2.2rem;
    border-radius: 2.2rem;
    margin-top: 3px;
    color: ${({ color }) => color};
    font-size: 1.7rem;
    background-color: ${({ bgColor }) => bgColor};
    box-shadow: ${({ shadow }) => shadow};
  `,
  Bar: styled.span`
    display: inline-block;
    // z-index: -1;
    background: ${({ bgColor }) => bgColor};
    border: 1px solid #d5d5da;
    height: 6px;
    border-left: none;
    border-right: none;
  `,
  Circle: styled.div`
    position: relative;
    top: 0.7rem;
    background: ${({ bgColor }) => bgColor};
    width: 3rem;
    height: 3rem;
    border-radius: 3rem;
    border: 1px solid #d5d5da;
  `,
  Progress: styled.div`
    width: 50rem;
    height: 1.4rem;
    margin: 5rem;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    border-bottom: 1px solid black;

    & > .circle.active .title {
      color: #0c95be;
    }
  `,
};

const Progress = ({ data }) => {
  let { pdeGreen, ruYellow, grey4, greenCell, yellowCell } = theme.colors;

  let currentDone = {
    title: "Current",
    status:
      data.currentValue.length > 0 &&
      data.units.length > 0 &&
      data.currentJust.length > 0
        ? "done"
        : data.currentValue.length > 0 ||
          data.units.length > 0 ||
          data.currentJust.length > 0
        ? "active"
        : "incomplete",
  };
  let critDone = {
    title: "Criteria",
    status:
      data.criteriaLow.length > 0 &&
      data.criteriaHigh.length > 0 &&
      data.criteriaJust.length > 0 &&
      data.criteriaType.length > 0
        ? "done"
        : data.criteriaLow.length > 0 ||
          data.criteriaHigh.length > 0 ||
          data.currentJust.length > 0 ||
          data.criteriaType.length > 0
        ? "active"
        : "incomplete",
  };
  let trajDone = {
    title: "Trajectory",
    status:
      data.trajectLow.length > 0 &&
      data.trajectHigh.length > 0 &&
      data.trajectJust.length > 0
        ? "done"
        : data.trajectLow.length > 0 ||
          data.trajectHigh.length > 0 ||
          data.trajectJust.length > 0
        ? "active"
        : "incomplete",
  };
  let forecastDone = {
    title: "Forecast",
    status:
      data.forecastYears.length > 0 && data.forecastJust.length > 0
        ? "done"
        : data.forecastYears.length > 0 || data.forecastJust.length > 0
        ? "active"
        : "incomplete",
  };

  let circleArray = [currentDone, critDone, trajDone, forecastDone];

  let circleElems = circleArray.map((item, i) => (
    <Styles.Circle key={i} bgColor={item.status === "done" ? "#eee" : "#fff"}>
      <Styles.Label
        color={
          item.status === "done"
            ? "#fff"
            : item.status === "active"
            ? "#fff"
            : "#b5b5ba"
        }
        bgColor={
          item.status === "done"
            ? pdeGreen
            : item.status === "active"
            ? ruYellow
            : "inherit"
        }
        shadow={
          item.status === "done"
            ? "inset 0 0 2px rgba(0, 0, 0, .2)"
            : item.status === "active"
            ? "inset 0 0 2px rgba(0, 0, 0, .2)"
            : "inherit"
        }
      >
        {i + 1}
      </Styles.Label>
      <Styles.Title color={grey4}>{item.title}</Styles.Title>
    </Styles.Circle>
  ));

  return (
    <Styles.Progress>
      {/* <Styles.Bar 
    bgColor={data.status === 'done' ? '#eee' : data.status === 'active' ? 'linear-gradient(to right, #EEE 40%, #FFF 60%)':  '#fff'}
    /> */}
      <span>{data.title}</span>
      {circleElems}
    </Styles.Progress>
  );
};

export default Progress;
